<div class="preview-section">
  <div class="section-label">
    @if (textHasPlaceholders()) {
      <div class="checkbox-container">
        <mat-checkbox [checked]="displayChips()" (change)="displayChips.set($event.checked)">Display placeholders</mat-checkbox>
        <mat-checkbox [checked]="useSample()" (change)="useSample.set($event.checked)">Use sample value</mat-checkbox>
      </div>
    }
  </div>
  <div class="chat">
    <div class="yours messages">
      <div class="message last" [innerHtml]="previewHtml()"></div>
    </div>
  </div>
</div>